import React from "react";
import { Modal, Button } from "react-bootstrap";

const DeleteRepository = ({ showModal, hideModal, confirmModal, deletename, message }) => {
  return (
    <Modal show={showModal} onHide={hideModal} className="custom-modal-width-delete" centered>
      <Modal.Header>{/* <Modal.Title style={{ fontSize: '16px' }}>Deactivation Confirmation</Modal.Title> */}</Modal.Header>
      <Modal.Body>
        <div className="" style={{ wordWrap: "break-word", padding: "22px", fontSize: "15px", textAlign: "center" }}>
          <img src="../assets/img/reports/delete-popup.svg" style={{ width: "30px", height: "30px", marginBottom: "20px" }} />
          <h4 style={{ color: "#CC2229", fontSize: "20px" }}>Delete File</h4>
          {message}
        </div>
      </Modal.Body>
      <Modal.Footer className="delete-modal-buttons">
        <Button className="btn-cancel outline-btn" variant="default" onClick={hideModal}>
          Cancel
        </Button>
        <Button variant="danger" className="btn-deactive" onClick={() => confirmModal(deletename)}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteRepository;
